<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                left-text="返回"
                fixed
                title="会员卡管理"
                left-arrow
                right-text="新增会员卡"
                @click-left="onClickLeft"
                @click-right="onClickRight"

        >
            <!--通过插槽自定义导航栏右侧的内容 end-->
        </van-nav-bar>
        <!--导航栏 end-->
        <!-- 列表 start-->
        <van-grid :column-num="4" :border="false" style="margin-top: 1rem">
            <van-grid-item  text="会员卡名称" />
            <van-grid-item  text="充值优惠配置" />
            <van-grid-item  text="小程序码" />
            <van-grid-item  text="操作" />
        </van-grid>
        <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="init"
        >
            <van-cell v-for="item in list" :key="item.id" @click.prevent="card_info(item.id)">
                <van-grid :column-num="4" :border="false">
                    <van-grid-item :text="item.name" />
                    <van-grid-item>				
						<div  v-for="(i,k) in item.discount" :key="k">
							{{'充值'+i.recharge+'优惠'+i.discount}}
						</div>
					</van-grid-item>
                    <van-grid-item>
						<van-image
						  width="40"
						  height="40"
						  :src="Config.baseURL+item.code_url"
						/>
                    </van-grid-item>
                    <van-grid-item>
                        <van-button @click.stop="card_detail(item.id)" style="width: 1.5rem;height: 0.6rem;position:relative; left: 0.2rem;" size="small"  type="danger">删除</van-button>
                    </van-grid-item>

<!--                    <van-grid-item v-if="item.is_audit_status == 1">审核中</van-grid-item>-->
<!--                    <van-grid-item v-if="item.is_audit_status == 0">已审核</van-grid-item>-->
                </van-grid>
            </van-cell>
        </van-list>
        <!-- 列表 end-->
    </div>
</template>

<script>
    import Vue from 'vue';
    import {List, Grid, GridItem,Dialog, Notify} from 'vant';
	import Config from "../../../config";
    // import VueCookie from "vue-cookies";

    Vue.use(Grid);
    Vue.use(GridItem);
    Vue.use(List);

    export default {
        name: "member_card",
        data(){
            return{
                list: [],
                page:1,
                limit:10,
                loading: false,
                finished: false,
            }
        },
        methods:{
            // 返回上一级
            onClickLeft() {
                // 返回商户信息
                this.$router.push('/member');
            },
            onClickRight(){
                this.$router.push('/member_card_add')
            },
            init() {
                var that = this;
                // var salesmanInfo = VueCookie.get("salesmanInfo");
                this.$http.post('/wechat/api.card/listCard', {
                    
                        // id: salesmanInfo.id,
                        pageNum: that.page,
                        pageSize:that.limit
                    
                }).then(response => {
                    // 加载状态结束
                    that.loading = false;
                    // console.log(response.data.data)
                    that.list = that.list.concat(response.data.rows)
                    // 页码
                    that.page++;
                    // this.finished = true;
                    if (response.data.rows.length < that.limit)
                    {
                        that.finished = true;
                    }
                });
            },
            card_info(id) {
                // this.$router.push("/SalesmanUpdate/"+id);
                this.$router.push({path:"/member_card_update", query:{id:id}})
                // this.$router.push({path:"/SalesmanUpdate", params:{id:id}})
            },
            card_detail(id){
                Dialog.confirm({
                    title: '删除会员卡',
                    message: '确定删除该会员卡吗?',
                })  .then(() => {
                    this.$http.get('/wechat/api.card/delCard', {params:
                        {
							id:id,
							// openid: window.localStorage.getItem("openid")
                        }
                    }).then(response => {
						console.log('qqqqqqqqqq',response)
                        if (response && response.body.code== 200) {
							console.log('cccccccccccccccc')
                            Notify({type: 'success', message: response.body.msg});
                            setTimeout(()=>{
                                this.$router.go(0)
                            },200)

                        }else {
                            Notify({type: 'danger',message:response.body.msg});
                        }
                    })
                })


            },
        },

    }
</script>

<style scoped>

</style>
